export default __webpack_public_path__ + "static/media/daftar.6e9d9e1a.svg";